// extracted by mini-css-extract-plugin
export default {"mainModal":"FilePreviewModal_mainModal__rHUpH","p_moduleBody":"FilePreviewModal_p_moduleBody__5E0tC","Modal":"FilePreviewModal_Modal__IHwtd"};